import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { FallecimientoService } from 'src/app/services/fallecimiento/fallecimiento.service';
import { PrestamosService } from 'src/app/services/prestamos/prestamos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { ReembolsosService } from 'src/app/services/reembolsos/reembolsos.service';
import { Usuario } from '../../models/usuario/usuario.model';
import { AfiliacionService } from '../../services/afiliacion/afiliacion.service';
import { Hijo } from '../../models/hijo/hijo.model';
import { Beneficiario } from '../../models/beneficiario/beneficiario.model';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';
import { TextosService } from '../../services/textos/textos.service';

import Swal from 'sweetalert2';

declare const Rut: any;
declare const ageCalculator: any;

@Component({
  selector: 'app-fallecimiento',
  templateUrl: '../../pages/fallecimiento/fallecimiento.component.html',
  styleUrls: ['../../pages/fallecimiento/fallecimiento.component.css']
})

export class FallecimientoComponent implements OnInit {

  rol: string = localStorage.getItem("rol")
  nombreUsuario: string = localStorage.getItem("nombreUsuario")
  estado: any
  idEjecutivo = localStorage.getItem("idUsuario")
  rutUsuario = localStorage.getItem("rutUsuario")
  regiones: any
  comunas: any
  tipoIngreso: any
  nacido: boolean = false
  mostrarBeneficiarios: boolean = true
  mostrarTitularCarga: boolean = true
  totalMaximo: any
  diasDiferencia: any
  scales: any
  tipos: any
  textos: any
  linkTexto: any
  postulantes: any[];
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  afiliado: any = { rutAfiliado: '', idAfiliado: '', nombreAfiliado: '', apellidoAfiliado: '' };
  //  beneficiario: any = { rutBeneficiario: '', nombreApellidoBeneficiario: '', parentescoBeneficiario: '', capitalBeneficiario: '' };
  beneficiarios: Beneficiario[] = [];
  beneficiariosArray: Beneficiario[] = [];
  cantidadArchivos: any = 1
  sumaCapital: number = 0
  buscador: any =
    {
      rut: '', rut2: '', rutConyuge: '', rutAfiliado: '', idRegion: '', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
      estado: ['INGRESADA', 'EN VALIDACION', 'RECHAZADA', 'APROBADA']
    }
  fallecimiento: any = {
    rutAfiliado: '', rutHijo: '', scales: '', nombreHijo: '', tipoCatastrofe: 0, fechaFallecimiento: '',
    nomNacDeshabilitado:false ,archivo: [], archivoTest: null, archivoTest2: null, archivoTest3: null, archivoTest4: null, archivoTest5: null, archivoTest6: null
  }

  constructor(private router: Router, public fallecimientoService: FallecimientoService, private escolaridadService: EscolaridadService, private reembolsosService: ReembolsosService,
    public prestamosService: PrestamosService, private productosService: ProductosService, private dialog: MatDialog,
    private postulacionesService: PostulacionesService, private mantenedorUsuarioService: MantenedorUsuariosService, private afiliacionService: AfiliacionService,
    private textosService: TextosService) {

  }

  ngOnInit(): void { this.loadData() }
  loadData() {
    let vm = this
    this.nacido = false
    this.mostrarTitularCarga = true
    if (this.rol == 'ROLE_AFILIADO' || this.rol == 'ROLE_JUBILADO') {
      this.afiliado.nombreAfiliado = this.nombreUsuario;
      this.afiliado.rutAfiliado = this.rutUsuario;
      this.afiliado.idAfiliado = this.idEjecutivo;
      this.mostrarBeneficiarios = false
      console.log('uno',this.rutUsuario)
      this.traePostulantes(this.rutUsuario, 3)
    }

    this.mantenedorUsuarioService.traeRegiones().then
      (regiones => { vm.regiones = regiones })

    this.fallecimientoService.traeTipoFallecimiento().then(
      tipo => this.tipos = tipo
    ).catch(error => console.log(error))

    this.productosService.obtieneProductos().then
      (
        productos => productos[9].parametros.map(parametro => {
          console.log('parametro1:', parametro)
          if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_CATASTROFE') {
            vm.diasDiferencia = parametro.valor
          }
        })
      )
      .catch(error => console.log(error))


      this.textosService.obtieneTextos()
      .then(textos => {
        vm.textos = textos; // Asigna el resultado del servicio a `this.textos`
        vm.linkTexto = vm.textos.find(item => item.tipoProducto === "FALLECIMIENTO")?.valor;             
      })
      .catch(error => {
        console.error('Error al obtener los textos:', error);
      });

  }

  traeComunas() {
    let vm = this

    this.comunas = []

    this.mantenedorUsuarioService.traeComunas(this.fallecimiento.region).then(comunas => vm.comunas = comunas)
  }


  sumaArchivo() {
    if (this.cantidadArchivos <= 5) {

      this.cantidadArchivos = this.cantidadArchivos + 1
    }
  }


  restaArchivo() {
    this.cantidadArchivos = this.cantidadArchivos - 1
    this.fallecimiento.archivo.splice(this.cantidadArchivos, 1);
  }

  buscaRegistroCivil(rutABuscar: any, ubicacion: any) {
    if (Rut(rutABuscar)) {
      let rut = rutABuscar.split('.').join('').split('-')[0]
      this.traePostulantes(rut, ubicacion)
    }
    else {
      console.log(rutABuscar)
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
    }
  }

  traePostulantes(rut: any, ubicacion: any) {
    if(this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO'){  
      this.validarEstado(rut.split('-')[0] )
    }
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    this.prestamosService.traePostulantes(rut).then
      (
        (usuario: Usuario) => {

          vm.nombreUsuario = usuario.nombres + ' ' + usuario.apellidoPaterno

          let usuariosPostulantes: Array<Usuario> = []
          if (this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO') {
            usuariosPostulantes.push({
              id: usuario.id, nombres: usuario.nombres,
              apellidoPaterno: usuario.apellidoPaterno, apellidoMaterno: usuario.apellidoMaterno,
              fechaNacimiento: ageCalculator(usuario.fechaNacimiento), sexo: usuario.sexo, rut: usuario.rut,
              dv: usuario.dv, parentesco: 'TITULAR', fechaAfiliacion: usuario.fechaAfiliacion
            })

          }
          usuario.carga ? usuario.carga.forEach(carga => {
            carga.fechaNacimiento = ageCalculator(carga.fechaNacimiento)
            carga.fechaAfiliacion = carga.fechaCreacion

            usuariosPostulantes.push(carga)
          }) : null;
          Swal.close();
          vm.afiliado.idAfiliado = usuario.id
          vm.postulantes = usuariosPostulantes

        }

      ).catch(error => {
        console.log(error)
        Swal.close();
        vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado. Intente nuevamente.', 'btn-danger')
      })
  }

  validarEstado(rutAfiliado){
    this.afiliacionService.traeSoloAfiliadoSinEstados(rutAfiliado).then
    ( 
        (response: any) => {
            if(response.estadoAfiliado  && (response.estadoAfiliado.toUpperCase() =='PENDIENTE_AFILIACION'
                || response.estadoAfiliado.toUpperCase() =='DESAFILIADO'
                    || response.estadoAfiliado.toUpperCase() =='RECHAZAR_AFILIACION')){
                        console.log(response.estadoAfiliado)
                this.openAlertDialog('El afiliado se encuentra cerrado o en estado pendiente para solicitar beneficios.', 'btn-danger')
                this.router.navigate(['/index'])                 
            }
        }
    )
    .catch
    (
        error => {
        console.log('error :',error);
        }
    ) 
}
  /*
  buscarHijo(rutABuscar) {
    let rut = rutABuscar.split('-')[0] + rutABuscar.split('-')[1]
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    if (Rut(rutABuscar)) {

      this.fallecimientoService.buscarHijo(rut).then
        (
          (hijo: Hijo) => {

            console.log(hijo)
            vm.fallecimiento.nombreConyugue = hijo.nombres
            vm.fallecimiento.run = hijo.run


            Swal.close();
          }

        ).catch(error => {
          console.log(error)
          Swal.close();
          vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado en el registro civil. Intente nuevamente.', 'btn-danger')
          vm.fallecimiento.nombres = ''
          vm.fallecimiento.run = ''
          vm.fallecimiento.fechaUnion = ''
        })
    } else {
      Swal.close();
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
      vm.fallecimiento.nombreConyugue = ''
      vm.fallecimiento.run = ''
      vm.fallecimiento.fechaUnion = ''
    }
  }
  */


  seleccionaArchivo(event: any, numero: number) {
    if (event.target.files.length > 0) {
      console.log(event.target.files[0].type)

      let vm = this
      let reader = new FileReader()
      this.fallecimiento.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
      reader.readAsDataURL(event.target.files[0])

      reader.onload = function () {
        vm.fallecimiento.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }


      }
    }
  }


  solicitar(form: NgForm) {
    var vm = this
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });

    let idUsuarioSesion = localStorage.getItem("idUsuario")
    let usuarioId: any
    let usuarioSeleccionado: any
    let usuarioIdSel: any, cargaId: any, titular: any;
    Swal.showLoading();
    usuarioId = this.afiliado.idAfiliado;
    if (vm.postulantes != null && this.fallecimiento.beneficiario) {

      usuarioSeleccionado = this.postulantes[this.fallecimiento.beneficiario]
      let usuarioTitular = usuarioSeleccionado
      this.postulantes.forEach(postulante => {
        if (postulante.parentesco == 'TITULAR') {
          usuarioTitular = postulante
        }

      })
      if (usuarioSeleccionado.parentesco == 'TITULAR') {
        titular = true
        usuarioIdSel = usuarioSeleccionado.id
      }
      else {
        titular = false
        cargaId = usuarioSeleccionado.id
      }
    }
    

    if (!usuarioId) {
      Swal.close();
      this.openAlertDialog('Debe ingresar un usuario válido', 'btn-dark')
      return false    
    }
  
    if (this.fallecimiento.rutHijo && !Rut(this.fallecimiento.rutHijo)) {
      Swal.close();
      this.openAlertDialog('El rut no tiene un formato válido', 'btn-dark')
      return false    
    }

    if (!vm.fallecimiento.archivo[0]) {
      Swal.close();
      this.openAlertDialog('Es obligatorio adjuntar un certificado', 'btn-dark')
      return false
    }

    if (vm.fallecimiento.archivo[0].extension != "application/pdf" && vm.fallecimiento.archivo[0].extension != "image/jpeg" &&
      vm.fallecimiento.archivo[0].extension != "image/png" && vm.fallecimiento.archivo[0].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (vm.fallecimiento.archivo[1] && vm.fallecimiento.archivo[1].extension != "application/pdf" && vm.fallecimiento.archivo[1].extension != "image/jpeg" &&
      vm.fallecimiento.archivo[1].extension != "image/png" && vm.fallecimiento.archivo[1].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (vm.fallecimiento.archivo[2] && vm.fallecimiento.archivo[2].extension != "application/pdf" && vm.fallecimiento.archivo[2].extension != "image/jpeg" &&
      vm.fallecimiento.archivo[2].extension != "image/png" && vm.fallecimiento.archivo[2].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (vm.fallecimiento.archivo[3] && vm.fallecimiento.archivo[3].extension != "application/pdf" && vm.fallecimiento.archivo[3].extension != "image/jpeg" &&
      vm.fallecimiento.archivo[3].extension != "image/png" && vm.fallecimiento.archivo[3].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (vm.fallecimiento.archivo[4] && vm.fallecimiento.archivo[4].extension != "application/pdf" && vm.fallecimiento.archivo[4].extension != "image/jpeg" &&
      vm.fallecimiento.archivo[4].extension != "image/png" && vm.fallecimiento.archivo[4].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }

    if (vm.fallecimiento.archivo[5] && vm.fallecimiento.archivo[5].extension != "application/pdf" && vm.fallecimiento.archivo[5].extension != "image/jpeg" &&
      vm.fallecimiento.archivo[5].extension != "image/png" && vm.fallecimiento.archivo[5].extension != "image/jpg") {
      Swal.close();
      this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      return false
    }


  

    let fechaFall = new Date(this.fallecimiento.fechaFallecimiento + 'T00:00')
    let fechamaxima = new Date()



    if (fechaFall > fechamaxima) {
      Swal.close();
      this.openAlertDialog('La fecha de catastrofe no debe super la fecha actual. Favor revisar.', 'btn-dark')
      return false
    }

    if (!this.fallecimiento.archivo) {
      Swal.close();
      this.openAlertDialog('Debe cargar el certificado como archivo', 'btn-dark')

      return false
    }

    if (!form.valid) {
      Swal.close();
      this.openAlertDialog('Debe ingresar todos los campos obligatorios', 'btn-dark')

      return false
    }

    let fechaFallIngresada = new Date(this.fallecimiento.fechaFallecimiento + 'T00:00')
    let fechaMinima = new Date()
    fechaMinima.setDate(fechaMinima.getDate() - this.diasDiferencia)

    if ((fechaFallIngresada < fechaMinima || fechaFallIngresada > new Date())) {
      this.openAlertDialog('La Fecha de solicitud supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
      Swal.close();
      return false
    }

    let fechaFallecimiento = this.fallecimiento.fechaFallecimiento.split('-')[2] + '-' +
      this.fallecimiento.fechaFallecimiento.split('-')[1] + '-' +
      this.fallecimiento.fechaFallecimiento.split('-')[0]

    if (this.beneficiarios) {
      this.limpiarBeneficiarios(this.beneficiarios)
    }

    this.fallecimientoService.ingresarFallecimiento(this.fallecimiento, fechaFallecimiento, usuarioId, cargaId, idUsuarioSesion, this.fallecimiento.scales, this.beneficiariosArray, vm.idEjecutivo).then
      (
        response => {
          console.log(response)
          Swal.close();
          vm.openAlertDialog('Se ha ingresado la solicitud correctamente.', 'btn-success')
          vm.limpiarFormulario();
          vm.fallecimiento.archivo.bytes = null, vm.fallecimiento.archivo.tipo = null
          form.reset()
          return
        }
      )
      .catch
      (error => {
        if (error.status == 402) {
          vm.openAlertDialog('Afiliado no cumple con su periodo de carencia.', 'btn-danger')
          Swal.close();
        }else if (error.status == 406) {
          vm.openAlertDialog('El afiliado ya tiene una solicitud para el mismo rut de hijo.', 'btn-danger')
          Swal.close();
        }else if (error.status == 410) {
          vm.openAlertDialog('Ya existe el rut del recién nacido asociado a otro afiliado.', 'btn-danger')
          Swal.close();
        } else if(error.status == 412){
          vm.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
          Swal.close();
        }else if (error.status == 423) {
          vm.openAlertDialog('El afiliado ya tiene una solicitud de fallecimiento para la carga', 'btn-danger')
          Swal.close();
        } else if (error.status == 409) {
          vm.openAlertDialog('El afiliado ya tiene una solicitud de fallecimiento', 'btn-danger')
          Swal.close();
        }else {
          vm.openAlertDialog('El sistema no ha podido generar su solicitud.', 'btn-danger')
          Swal.close();
        }
      }
      )
  }


  muestraRecienNacido(event: any) {
    let vm = this
    this.nacido = false;

    if (event.target.checked) {
      this.nacido = true;
      this.mostrarTitularCarga = false;
      if (this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO') {
        this.mostrarBeneficiarios = false;
      }
    } else {
      this.nacido = false;
      this.mostrarTitularCarga = true;
      if (this.rol != 'ROLE_AFILIADO' && this.rol != 'ROLE_JUBILADO') {
        this.mostrarBeneficiarios = true;
      }
    }

  }

  esconderBeneficiarios(parentesco: string) {
    let vm = this
    this.mostrarBeneficiarios = false;

    if (parentesco == 'TITULAR' && vm.fallecimiento.scales == false) {
      this.mostrarBeneficiarios = true;
    } else {
      this.mostrarBeneficiarios = false;
    }
  }


  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }



  salir() {
    const dialogRef = this.dialog.open(ConfirmationDialog, {
      data: { message: '¿Esta seguro de salir del formulario?', buttonText: { ok: 'Si', cancel: 'No' } }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) { this.router.navigate(['/index']); }
    });
  }

  validateFormat(event) {
    let key;
    if (event.type === 'paste') {
      key = event.clipboardData.getData('text/plain');
    } else {
      key = event.keyCode;
      key = String.fromCharCode(key);
    }
    const regex = /[0-9]|\./;
    if (!regex.test(key)) {
      event.returnValue = false;
      if (event.preventDefault) {
        event.preventDefault();
      }
    }
  }


  agregarBeneficiario(form: NgForm) {
    let vm = this
    let beneficiarioAgregado: any = []
    let tipoIngresoParentesco: any
    let tipoParentescoId: any

    if (!vm.fallecimiento.nombreApellidoBeneficiario) {
      vm.openAlertDialog('El campo nombre y apellido no debe ir vacio', 'btn-danger')
      Swal.close();
      return false;
    }

    if (vm.fallecimiento.rutBeneficiario == vm.buscador.rutAfiliado) {
      vm.openAlertDialog('El rut del beneficiario no debe ser igual al del titular', 'btn-danger')
      Swal.close();
      return false;
    }


    if (!vm.fallecimiento.rutBeneficiario) {
      vm.openAlertDialog('El campo rut no debe ir vacio', 'btn-danger')
      Swal.close();
      return false;
    }

    if (!Rut(vm.fallecimiento.rutBeneficiario)) {
      console.log(vm.fallecimiento.rutBeneficiario)
      this.openAlertDialog('El RUT tiene un formato incorrecto. Favor Revisar', 'btn-danger')
      Swal.close();
      return false;
    }

    if (!vm.fallecimiento.capitalBeneficiario) {
      vm.openAlertDialog('El campo capital no debe ir vacio', 'btn-danger')
      Swal.close();
      return false;
    }

    if (vm.fallecimiento.capitalBeneficiario < 1 || vm.fallecimiento.capitalBeneficiario > 100) {
      vm.openAlertDialog('El porcentaje del capital debe ir entre 1 y 100 %', 'btn-danger')
      Swal.close();
      return false;
    }

    if (Number(this.sumaCapital) + Number(vm.fallecimiento.capitalBeneficiario) > 100) {
      vm.openAlertDialog('El porcentaje sumado de los beneficiarios no debe superar el 100%', 'btn-danger')
      Swal.close();
      return false;
    }


    for (let i = 0; i < this.tipos.length; i++) {
      if (this.tipos[i].id == vm.fallecimiento.tipoParentesco) {
        tipoIngresoParentesco = this.tipos[i].descripcion;
        tipoParentescoId = this.tipos[i].id;
      }
    }

    beneficiarioAgregado.push({
      nombreApellidoBeneficiario: vm.fallecimiento.nombreApellidoBeneficiario,
      parentescoBeneficiario: tipoIngresoParentesco,
      tipoParentescoId: tipoParentescoId,
      rutBeneficiario: vm.fallecimiento.rutBeneficiario,
      nombres: vm.fallecimiento.parentescoBeneficiario,
      capitalBeneficiario: vm.fallecimiento.capitalBeneficiario,
    })

    this.sumaCapital = Number(this.sumaCapital) + Number(vm.fallecimiento.capitalBeneficiario);


    vm.beneficiarios.push(beneficiarioAgregado)

    vm.fallecimiento.nombreApellidoBeneficiario = ''
    vm.fallecimiento.tipoIngresoParentesco = 0
    vm.fallecimiento.tipoParentescoId = 0
    vm.fallecimiento.rutBeneficiario = ''
    vm.fallecimiento.tipoParentesco = 0
    vm.fallecimiento.capitalBeneficiario = ''


    vm.config.currentPage = 1
    vm.config.totalItems = 5


  }


  limpiarBeneficiarios(beneficiarios: any) {
    let arrayBeneficiario: Array<Beneficiario> = []
    for (let i = 0; i < this.beneficiarios.length; i++) {

      arrayBeneficiario.push(this.beneficiarios[i][0]);
    }
    this.beneficiariosArray = arrayBeneficiario
  }


  limpiarFormulario() {
    var vm = this
    vm.fallecimiento.scales = ''
    vm.fallecimiento.rutHijo = ''
    vm.fallecimiento.nombreHijo = ''
    vm.fallecimiento.fechaFallecimiento = ''
    vm.fallecimiento.archivoTest = ''
    vm.fallecimiento.archivoTest2 = ''
    vm.fallecimiento.archivoTest3 = ''
    vm.fallecimiento.archivoTest4 = ''
    vm.fallecimiento.archivoTest5 = ''
    vm.fallecimiento.archivoTest6 = ''
    vm.fallecimiento.rutBeneficiario = ''
    vm.fallecimiento.nombreApellidoBeneficiario = ''
    vm.fallecimiento.nombreApellidoBeneficiario = ''
    vm.fallecimiento.tipoParentesco = 0
    vm.fallecimiento.capitalBeneficiario = ''
    vm.afiliado.nombreAfiliado = ''
    vm.afiliado.rutAfiliado = ''
    vm.afiliado.idAfiliado = ''
    vm.buscador.rutAfiliado = ''
    vm.fallecimiento.beneficiarios = '';
    vm.postulantes = []
    vm.beneficiarios = []
  }


  buscarHijo(rutABuscar) {
    let rut = rutABuscar.split('-')[0] + rutABuscar.split('-')[1]
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Cargando...'
    });
    Swal.showLoading();
    let vm = this
    if (Rut(rutABuscar)) {

      this.fallecimientoService.buscarHijo(rut).then
        (
          (hijo: Hijo) => {
            console.log(hijo)
            vm.fallecimiento.nombreHijo = hijo.nombres
            vm.fallecimiento.nomNacDeshabilitado = true
            Swal.close();
          }

        ).catch(error => {
          console.log(error)
          Swal.close();
          vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado en el registro civil. Intente nuevamente.', 'btn-danger')
          vm.fallecimiento.nombreHijo = ''
          vm.fallecimiento.nomNacDeshabilitado = false
      
        
        })
    } else {
      Swal.close();
      this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
      vm.fallecimiento.nombreHijo = ''
      vm.fallecimiento.nomNacDeshabilitado = false
     // vm.fallecimiento.rutHijo = ''
    }
  }

}
